var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"_p-1 border-box scroll-y with-custom-scrollbar"},[_c('div',{ref:"editor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }